module.exports = __webpack_public_path__ + "media/images/games/clash-royale/background-4d76357386c5d4a8c820fb304dbd333d.jpg";